import { HOME_WIDGETS_PRIORITY } from './constants';
import type { HomeWidget, HomeWidgetsPriority } from './types';

const sortByWeight = (a: HomeWidget, b: HomeWidget) => {
  const orderA = a.weight || 0;
  const orderB = b.weight || 0;
  if (orderA < orderB) {
    return 1;
  } else if (orderA > orderB) {
    return -1;
  } else {
    return 0;
  }
};

export const sortHomeWidgets = (widgetsList: HomeWidget[], priority?: HomeWidgetsPriority) => {
  const widgetsPriority = priority ?? HOME_WIDGETS_PRIORITY;

  return widgetsList.sort((a, b) => {
    const orderA = widgetsPriority[a.type];
    const orderB = widgetsPriority[b.type];
    if (orderA < orderB) {
      return -1;
    } else if (orderA > orderB) {
      return 1;
    } else {
      return sortByWeight(a, b);
    }
  });
};
